// extracted by mini-css-extract-plugin
export default {"emptyAvatar":"EmptyAvatar_emptyAvatar__qDE6e","emptyBlock":"EmptyAvatar_emptyBlock__7U15l"};